module.exports = __webpack_public_path__ + "media/images/icons/more_vertical-78d06cea8f783e901c23d6f419cd64d7.svg";